module.exports = __webpack_public_path__ + "overview-a5b6df21/video-c942510ba422e55ebbc79788086e1b55.svg";